import axios from 'axios';
import camelCase from 'lodash.camelcase';
import snakeCase from 'lodash.snakecase';
import qs from 'qs';
import deepMapKeys from '@/helper/deepMapKeys';
import { Authentication } from '@/components/Authentication';

const baseURL =
  process.env.VUE_APP_BASE_URL === undefined ? 'https://stg-api.motch.info' : process.env.VUE_APP_BASE_URL;

const apiInstance = axios.create({
  baseURL,
  // レスポンスをcamelCaseに変換
  // axiosのデフォルト処理に追加するために、concatで配列の最後に追加する。
  // (※ pushするとすべてのインスタンスの共通処理が変わってしまう)
  transformResponse: [
    ...axios.defaults.transformResponse,
    (data, headers) => {
      if (
        !headers['content-type'] ||
        headers['content-type'].indexOf('application/json') === -1
      ) {
        return data;
      }
      return deepMapKeys(data, (val, key) => {
        return camelCase(key);
      });
    },
  ],

  // リクエストをsnake_caseに変換
  // こちらはaxiosのデフォルト処理がJSONをstringifyする前に実行したいので、配列の最初に追加する。
  transformRequest: [
    (data, headers) => {
      if (data instanceof FormData) {
        return data;
      }
      return deepMapKeys(data, (val, key) => {
        return snakeCase(key);
      });
    },
    ...axios.defaults.transformRequest,
  ],

  // GETリクエストのパラメーターもsnake_caseに変換。
  paramsSerializer(params) {
    return qs.stringify(
      deepMapKeys(params, (val, key) => {
        return snakeCase(key);
      }),
    );
  },
});

// axiosでリクエスト/レスポンスのcamelCase/snake_case自動変換
// https://qiita.com/mimaun/items/51a036037bdca85f8ad4
// 【Vue.js】Web API通信のデザインパターン (個人的ベストプラクティス)
// https://qiita.com/07JP27/items/0923cbe3b6435c19d761

apiInstance.interceptors.request.use(async (config) => {
  config.headers.Authorization = await Authentication.idToken;
  return config;
});

export default apiInstance;
